import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaAngleDown } from "react-icons/fa";


const NavSoftweb = ({ onNavigate }) => {

    const navigate = useNavigate();

    const handleNavigate = (event, section, extra = {}) => {

        event.preventDefault();

        // Si estamos en HomeStartup, usamos el comportamiento actual.
        if (typeof onNavigate === 'function') {
            onNavigate(section, extra);
            return;
        }

        // Si estamos en otra página, regresamos al Home.
        navigate(
            `${process.env.PUBLIC_URL}/#${section}`,
            {
                state: extra
            }
        );
    };

    return (
        <nav className="mainmenu-nav">
            <ul className="mainmenu">
                <li>
                    <Link onClick={(event) => handleNavigate(event, 'inicio')} to={`${process.env.PUBLIC_URL}/#inicio`}>Inicio</Link>
                </li>
                <li>
                    <Link onClick={(event) => handleNavigate(event, 'servicios')} to={`${process.env.PUBLIC_URL}/#servicios`}>Servicios</Link>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Planes <FaAngleDown /> </Link>
                    <ul className="axil-submenu">
                        <li>
                            <Link to={`${process.env.PUBLIC_URL}/#planes`} onClick={(event) => handleNavigate(event, 'planes', { tabId: 1 })}>
                                Facturacion
                            </Link>
                        </li>
                        <li>
                            <Link to={`${process.env.PUBLIC_URL}/#planes`} onClick={(event) => handleNavigate(event, 'planes', { tabId: 2 })}>
                                Punto De Venta
                            </Link>
                        </li>
                        <li>
                            <Link to={`${process.env.PUBLIC_URL}/#planes`} onClick={(event) => handleNavigate(event, 'planes', { tabId: 3 })}>
                                Nomina
                            </Link>
                        </li>
                        <li>
                            <Link to={`${process.env.PUBLIC_URL}/#planes`} onClick={(event) => handleNavigate(event, 'planes', { tabId: 4 })}>
                                Contabilidad
                            </Link>
                        </li>
                    </ul>
                </li>
                <li>
                    <Link onClick={(event) => handleNavigate(event, 'nosotros')} to={`${process.env.PUBLIC_URL}/#nosotros`}>Nosotros</Link>
                </li>
                {/* <li className="menu-item-has-children">
                    <Link to="#">Services <FaAngleDown /></Link>
                    <ul className="axil-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/service-one"}>Service</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/service-two"}>Service Two</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/service-details/design"}>Service Details</Link></li>
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Portfolio <FaAngleDown /></Link>
                    <ul className="axil-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/project-grid-one"}>Two Column</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-grid-two"}>Three Column</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-grid-three"}>Four Column</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-width-one"}>Three Column Width</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-width-two"}>Four Column Width</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/project-details/plan-management"}>Portfolio Details</Link></li>
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Pages <FaAngleDown /></Link>
                    <ul className="axil-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/about-us"}>About Us</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/our-office"}>Our Office</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/case-study"}>Case Study</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/case-details/whitehorse"}>Case Study Details</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/team"}>Team</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/team-details/jane-cooper"}>Team Details</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/our-clients"}>Our Clients</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/testimonials"}>Testimonial</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/pricing-table"}>Pricing Table</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/typography"}>Typography</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/404"}>404 Page</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/coming-soon"}>Coming Soon</Link></li>
                    </ul>
                </li>
                <li className="menu-item-has-children">
                    <Link to="#">Blog <FaAngleDown /></Link>
                    <ul className="axil-submenu">
                        <li><Link to={process.env.PUBLIC_URL + "/blog-grid"}>Blog</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/1"}>Standard Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/2"}>Gallery Post</Link></li>
                        <li><Link to={process.env.PUBLIC_URL + "/blog-details/3"}>Video Post</Link></li>
                    </ul>
                </li> */}
                <li>
                    <a href='https://login.softweb.mx/login'>
                        Iniciar Sesión
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default NavSoftweb;